import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$urlRouterProvider
		.when('/main', '/main/panels');

	$stateProvider.state('main', {
		url: '/main',
		template: template,
		controllerAs: 'ctrl',
		controller: controller,
		resolve: controller.resolve
	})
}


/** WEBPACK FOOTER **
 ** ./src/main/routes.js
 **/